module.exports = __webpack_public_path__ + "media/country_flags/fj-515f3b6c.png";